import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import { Link } from "@tiptap/extension-link";
import { useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { useState } from "react";
import { useSelector } from "react-redux";
import MenuBar from "./menu-bar";
import Editor from "./Editor";
import "./toolbar/styles.css";
import classes from "./TextEditor.module.css";

export default function TextEditor({ onChange, value, setDirty }) {
  const [initialHTML, setInitialHTML] = useState();
  const { language } = useSelector((state) => ({
    language: state.language,
  }));

  const editor = useEditor({
    extensions: [
      StarterKit,
      TextAlign.configure({
        types: ["heading", "paragraph"],
      }),
      Underline,
      Link.configure({
        openOnClick: false,
        autolink: true,
        linkOnPaste: true,
        defaultProtocol: "https",
      }),
    ],
    content: value || "",
    onUpdate: ({ editor }) => {
      const currentHTML = editor.getHTML();
      setDirty(currentHTML !== initialHTML);
      onChange(currentHTML);
    },
    onCreate: ({ editor }) => {
      if (value) {
        setInitialHTML(editor.getHTML());
        editor.commands.setContent(value);
      }
    },
  });

  return (
    <div className={classes.card}>
      <div className={`editor grow ${editor.isFocused ? "outline-ring" : ""}`}>
        <MenuBar editor={editor} language={language} />
        <div className={classes.textEditorBody}>
          <div className={classes.textEditorInnerWrapper}>
            <Editor editor={editor} />
          </div>
        </div>
      </div>
    </div>
  );
}
